<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-input [control]="form.controls['bsabCode']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
